import {
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  getUiState,
  getSidebarProFolders,
  getSidebarClientFolders,
} from 'web-selectors';

import {
  uiActions,
} from 'web-actions';

import {
  Sidebar,
} from 'web-components';
import {
  trackAnalyticsEvent,
} from 'web-utils';

const mapState = (state) => {
  const isPro = coreSelectors.getProfile('is_pro')(state);
  const items = isPro
    ? getSidebarProFolders(state)
    : getSidebarClientFolders(state);

  const {
    namespace,
    openedTooltips,
  } = getUiState([
    'namespace',
    'openedTooltips',
  ])(state);

  return {
    items,
    namespace,
    openedTooltips,
  };
};

const MainSidebar = () => {
  const {
    items,
    namespace,
    openedTooltips,
  } = useSelector(mapState);
  const dispatch = useDispatch();

  return (
    <Sidebar
      items={items}
      namespace={namespace}
      openedTooltips={openedTooltips}
      onClickItem={(e, item: any) => {
        if (item.requiresPremium) {
          e.preventDefault();
          e.stopPropagation();
          trackAnalyticsEvent('opened_upgrade_plan_popup')
          dispatch(
            uiActions.setUiState({
              upgradePlanModal: {
                isOpen: true,
              },
            }),
          );
        }

        if (openedTooltips.some(el => el.key === item.name)) {
          dispatch(
            uiActions.setUiState({
              openedTooltips: openedTooltips.filter(el => el.key !== item.name),
            }),
          );
        }
      }}
    />
  );
};

export default MainSidebar;
